import styled from '@emotion/styled';

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
`;

export const SectionTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #111827;
`;

export const CountBadge = styled.span`
    background: #fef3c7;
    color: #92400e;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
`;

export const TableWrapper = styled.div`
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    background: white;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const TableHeader = styled.th`
    padding: 12px 16px;
    text-align: left;
    font-weight: 500;
    color: #6b7280;
    background: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    font-size: 14px;
`;

export const TableRow = styled.tr`
    border-bottom: 1px solid #f3f4f6;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #f9fafb;
    }
`;

export const TableCell = styled.td`
    padding: 16px;
    color: #111827;
`;

export const ActionButtons = styled.div`
    display: flex;
    gap: 8px;
`;

export const StatusBadge = styled.span`
    background: #ede9fe;
    color: #6366f1;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
`;

export const EmptyState = styled.div`
    padding: 40px;
    text-align: center;
    color: #6b7280;
`;
